<template>
  <TheMenuLayout>
    <v-row>
      <v-col cols="12" class="text-center">
        <p>
          Bonjour {{ student.name }}
        </p>
        <p>
          Bienvenue sur votre espace personnel.
          <br>
          Vous êtes inscrit dans la section <strong v-if="student.faculty">{{ student.faculty.name }}</strong>,
          <br>
          dans le groupe <strong v-if="student.group">{{ student.group.name }}</strong>.
        </p>
      </v-col>
    </v-row>
    <BaseSectionHeader class="mb-2">
      Actualités
    </BaseSectionHeader>
    <BaseParagraph v-if="!sortedHomepages.length">
      Aucune actualité pour le moment.
    </BaseParagraph>
    <v-card
      v-for="homepage in sortedHomepages"
      :key="homepage.id"
      :href="homepage.link"
      class="mb-8"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title>{{ homepage.title }}</v-card-title>
          <v-card-subtitle v-if="homepage.subtitle">
            {{ homepage.subtitle }}
          </v-card-subtitle>
          <v-card-text><div v-html="homepage.content.body"/></v-card-text>
        </div>
        <v-avatar
          class="ma-3"
          size="250"
          tile
        >
          <v-img
            v-if="homepage.image_url"
            :src="homepage.image_url"
            max-width="250"
            max-height="250"
          />
        </v-avatar>
      </div>
    </v-card>

    <BaseSectionHeader class="mb-2">
      Plannings
    </BaseSectionHeader>

    <BaseParagraph v-if="!plannings.length">
      Aucun planning disponible
    </BaseParagraph>

    <v-card
      v-for="planning in plannings"
      :key="planning.id"
      :href="planning.file_url"
      link
      class="mb-4"
    >
      <v-card-title>
        <small>
          {{ planning.name }}
        </small>
      </v-card-title>
      <v-card-subtitle>
        Mis en ligne le {{ planning.created_at  | moment('LL') }} par {{ planning.author.name}}
      </v-card-subtitle>

    </v-card>
  </TheMenuLayout>
</template>

<script>
import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import { mapActions, mapState } from 'vuex';
import { orderBy } from 'lodash';
import BaseParagraph from '../components/BaseParagraph.vue';

export default {
  name: 'HomePage',
  components: {
    TheMenuLayout,
    BaseSectionHeader,
    BaseParagraph,
  },

  created() {
    this.checkSignIn();
    this.fetchPlannings();
    this.fetchHomepages();
  },

  methods: {
    ...mapActions('authentication', ['checkSignIn']),
    ...mapActions(['fetchPlannings', 'fetchHomepages']),
  },
  computed: {
    ...mapState('authentication', ['student']),
    ...mapState(['plannings', 'homepages']),
    sortedHomepages() {
      return orderBy(this.homepages, ['always_first', 'created_at'], ['desc', 'desc']);
    },
  },
};
</script>
